export default "/img/EG.a9f86b29a2dbafc788f6ea50630ac1dd.png";